<template>
<div>
  <el-popover ref="popover" width="400" popper-class="interface-select-popover" @show="onShown" @hide="onHidden">
    <div>
      <div>
        <span style="font-weight: bold;">장비명 : </span>{{ deviceName }}
      </div>
      <el-input style="padding: 10px 0px;" size="mini" suffix-icon="el-icon-search" v-model="keyword" placeholder="검색 키워드를 입력해주십시오."></el-input>
      <el-table ref="table" :data="filterData" @cell-click="onInterfaceSelect" height="300" style="width: 100%;" class="popup" :highlight-current-row="true">
        <el-table-column
          v-for="column in tableColumns"
          :key="column.key"
          :align="column.align"
          :label="column.label"
          :prop="column.prop"
          show-overflow-tooltip>
        </el-table-column>
      </el-table>
    </div>
    <el-tooltip :content="selectedInterfaceName" slot="reference" placement="top">
      <el-button class="interface-select-btn" style="width: 220px; overflow: hidden;vertical-align: middle;">{{ selectedInterfaceName }}</el-button>
    </el-tooltip>
  </el-popover>
  <el-tooltip content="선택 취소" :open-delay="MapConst.TOOLTIP_DELAY">
    <el-button icon="el-icon-delete" @click="onClearClick"></el-button>
  </el-tooltip>
</div>
</template>

<script>
import find from 'lodash/find';

import MapAPI from '@/api/topologymap/common';

import MapConst from '@/constants/topologymap';

import { isNumber } from '@/utils/number';

export default {
  name: 'WInterfaceSelect',
  props: ['object', 'direction'],
  data() {
    return {
      MapConst,
      /**
       * 인터페이스 목록
       * @type {Array}
       */
      interfaceList: [],
      /**
       * 선택 한 인터페이스 데이터
       * @type {Object]}
       */
      selectedInterface: null,
      /**
       * 검색어
       * @type {String}
       */
      keyword: '',
      tableColumns: [
        {
          prop: 'netinterfaceName',
          key: 'netinterfaceName',
          label: '인터페이스명',
          align: 'left',
        },
        {
          prop: 'netinterfaceDesc',
          key: 'netinterfaceDesc',
          label: '물리명',
          align: 'left',
        },
        {
          prop: 'netinterfaceAlias',
          key: 'netinterfaceAlias',
          label: '별칭',
          align: 'left',
        },
      ],
    };
  },
  computed: {
    /**
     * 테이블에 표현 할 데이터를 반환한다.
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    filterData() {
      return this.interfaceList.filter((value) => this.tableInterfaceLabel(value).toLowerCase().indexOf(this.keyword.toLowerCase()) > -1);
    },
    /**
     * 설정 된 인터페이스 이름을 반환한다.
     * @author KangBonghun(toto1323)
     * @return {String} 인터페이스 이름
     */
    selectedInterfaceName() {
      const ifObjId = this.object.get(`${this.direction === 'from' ? 'src' : 'dst'}ObjId`);

      if (isNumber(ifObjId) && ifObjId > 0) {
        let label = '';
        label += this.object.get(`${this.direction === 'from' ? 'src' : 'dst'}NetinterfaceName`) || '-';
        label += ' | ';
        label += this.object.get(`${this.direction === 'from' ? 'src' : 'dst'}NetinterfaceDesc`) || '-';
        label += ' | ';
        label += this.object.get(`${this.direction === 'from' ? 'src' : 'dst'}NetinterfaceAlias`) || '-';
        return label;
      }
      return '선택안됨';
    },
    /**
     * 네트워크 장비 이름을 반환한다.
     * @author KangBonghun(toto1323)
     * @return {String} 네트워크 장비 이름
     */
    deviceName() {
      return this.object[this.direction].get('objName');
    },
  },
  methods: {
    tableInterfaceLabel(data) {
      return `${data.netinterfaceName}${data.netinterfaceAlias}${data.netinterfaceDesc}`;
    },
    /**
     * 팝업이 보여지면 데이터를 로드한다.
     * @author KangBonghun(toto1323)
     */
    onShown() {
      this.loadData();
    },
    /**
     * 팝업이 숨겨지면 데이터 clear
     * @author KangBonghun(toto1323)
     */
    onHidden() {
      this.selectedInterface = null;
      this.keyword = '';
    },
    /**
     * 인터페이스 목록을 조회한다.
     * @author KangBonghun(toto1323)
     */
    loadData() {
      const objId = this.object[this.direction].get('objId');

      MapAPI.getNetinerfaceList(objId).then((response) => {
        const result = response.data;
        if (result.success) {
          this.interfaceList = result.data;
          this.$nextTick(() => {
            const selected = this.findSelectedData();
            this.$refs.table.setCurrentRow(selected);
          });
        }
      });
    },
    findSelectedData() {
      const netinterfaceObjId = this.object.get(`${this.direction === 'from' ? 'src' : 'dst'}ObjId`);
      if (netinterfaceObjId) {
        return find(this.interfaceList, ['objId', netinterfaceObjId]);
      }
      return null;
    },
    /**
     * 인터페이스 선택
     * @author KangBonghun(toto1323)
     * @param  {Object} row 선택한 인터페이스 데이터
     */
    onInterfaceSelect(row) {
      this.object.set(`${this.direction === 'from' ? 'src' : 'dst'}ObjId`, row.objId);
      this.object.set(`${this.direction === 'from' ? 'src' : 'dst'}NetinterfaceAlias`, row.netinterfaceAlias);
      this.object.set(`${this.direction === 'from' ? 'src' : 'dst'}NetinterfaceName`, row.netinterfaceName);
      this.object.set(`${this.direction === 'from' ? 'src' : 'dst'}NetinterfaceDesc`, row.netinterfaceDesc);
      this.$refs.popover.doClose();
    },
    onClearClick() {
      this.object.set(`${this.direction === 'from' ? 'src' : 'dst'}ObjId`, -1);
      this.object.set(`${this.direction === 'from' ? 'src' : 'dst'}ObjName`, null);
      this.object.set(`${this.direction === 'from' ? 'src' : 'dst'}NetinterfaceAlias`, null);
      this.object.set(`${this.direction === 'from' ? 'src' : 'dst'}NetinterfaceName`, null);
      this.object.set(`${this.direction === 'from' ? 'src' : 'dst'}NetinterfaceDesc`, null);
      this.selectedInterface = {};
    },
  },
};
</script>

<style lang="scss">
.interface-select-popover {
  .el-table tr {
    cursor: pointer;
  }
  .el-table__body tr.current-row>td {
    background-color: #ecf5ff !important;
  }
}
.interface-select-btn {
  & > span {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 100%;
    line-height: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/property/InterfaceSelect.vue